import {CommonModule} from '@angular/common';
import {Component, ElementRef, HostListener, Input, TemplateRef} from '@angular/core';
import {ButtonModule} from 'primeng/button';
import {DrawerEntry} from './app-drawer.types';

@Component({
	selector: 'ngx-app-template-drawer',
	standalone: true,
	imports: [CommonModule, ButtonModule],
	styles: [`
		:host {
			display: flex;
			flex-direction: column;
			flex: 1 1 auto;
			min-height: 0;
			width: 100%;
			height: 100%;
		}
	`],
	template: `
		<div class="app-drawer-frame" [class.app-drawer-frame--sticky-chrome]="entry.stickyChrome">
			<p-button
				*ngIf="entry.showCloseButton"
				type="button"
				class="app-drawer-close"
				icon="pi pi-times"
				size="small"
				[rounded]="true"
				[text]="true"
				severity="secondary"
				[attr.aria-label]="'Fermer'"
				(onClick)="close()"
			></p-button>
			<div class="app-drawer-scroll">
				<ng-container *ngTemplateOutlet="template; context: templateContext"></ng-container>
			</div>
		</div>
	`,
})
export class AppTemplateDrawerComponent {
	@Input({required: true}) entry!: DrawerEntry;

	constructor(private readonly hostRef: ElementRef<HTMLElement>) {
	}

	get template(): TemplateRef<unknown> {
		return this.entry.content as TemplateRef<unknown>;
	}

	@HostListener('document:keydown', ['$event'])
	onDocumentKeydown(event: KeyboardEvent): void {
		if (event.key !== 'Escape' || !this.entry.closeOnEscape) {
			return;
		}

		const hostDrawer = this.hostRef.nativeElement.closest('.p-drawer.app-dynamic-drawer') as HTMLElement | null;
		if (!hostDrawer?.isConnected || AppTemplateDrawerComponent.getTopDrawer() !== hostDrawer) {
			return;
		}

		event.preventDefault();
		event.stopImmediatePropagation();
		this.close();
	}

	close(): void {
		this.entry.ref.close();
	}

	get templateContext(): Record<string, unknown> {
		const ctx = this.entry.context;
		const spread =
			typeof ctx === 'object' && ctx !== null && !Array.isArray(ctx)
				? {...(ctx as Record<string, unknown>)}
				: {};

		return {
			...spread,
			$implicit: ctx,
			dialogRef: this.entry.ref,
			ref: this.entry.ref,
		};
	}

	private static getTopDrawer(): HTMLElement | null {
		const drawers = Array.from(document.querySelectorAll<HTMLElement>('.p-drawer.app-dynamic-drawer'));
		if (!drawers.length) {
			return null;
		}

		return drawers.reduce((top, drawer) => {
			const z = parseInt(drawer.style.zIndex || '0', 10);
			const topZ = parseInt(top.style.zIndex || '0', 10);
			return z >= topZ ? drawer : top;
		});
	}
}
